// src/hooks/useUserBlocking.ts
import { useMutation, useApolloClient } from '@apollo/client';
import { BLOCK_USER, UNBLOCK_USER } from '../graphql/mutations';
import { USERS } from '../graphql/queries';
import { User } from '../graphql/types';

export const useUserBlocking = (
  showNotification: (type: 'success' | 'error' | 'info' | 'warning', message: string) => void
) => {
  const client = useApolloClient();

  const [blockUserMutation] = useMutation(BLOCK_USER, {
  refetchQueries: [{ query: USERS }],
});

const [unblockUserMutation] = useMutation(UNBLOCK_USER, {
  refetchQueries: [{ query: USERS }],
});

  const updateUserInCache = (email: string, isBlocked: boolean) => {
    const data = client.readQuery<{ users: User[] }>({ query: USERS });
    if (!data) return;

    const updatedUsers = data.users.map(u =>
      u.email === email ? { ...u, isBlocked } : u
    );

    client.writeQuery({
      query: USERS,
      data: { users: updatedUsers },
    });
  };

  const blockUser = async (email: string) => {
    try {
      const { data } = await blockUserMutation({ variables: { email } });
      if (data?.blockUser) {
        updateUserInCache(email, true);
        showNotification('success', `Пользователь ${data.blockUser.username} заблокирован`);
      }
    } catch (err) {
      const message = (err as Error).message;
      showNotification('error', `Ошибка блокировки: ${message}`);
    }
  };

  const unblockUser = async (email: string) => {
    try {
      const { data } = await unblockUserMutation({ variables: { email } });
      if (data?.unblockUser) {
        updateUserInCache(email, false);
        showNotification('success', `Пользователь ${data.unblockUser.username} разблокирован`);
      }
    } catch (err) {
      const message = (err as Error).message;
      showNotification('error', `Ошибка разблокировки: ${message}`);
    }
  };

  return { blockUser, unblockUser };
};